import { ApSvgSprite } from '@agilepoint/web-components-react';
import * as React from 'react';

interface IRegisterIconSpritesProps {
    iconSprites?: IIconSprite[];
}

export interface IIconSprite {
    name: string;
    src: string;
}

export function IconSpritesRegistrar(props: IRegisterIconSpritesProps) {
    const { iconSprites = [] } = props;
    return React.useMemo(() => (
        <>
            {
                iconSprites.map((iconSprite: IIconSprite, index: number) =>
                <ApSvgSprite key={index} name={iconSprite.name} src={iconSprite.src}/>)
            }
        </>
    ), [iconSprites]);
}
